import { unsafeCSS } from "lit";
import globalStyles from "../tailwind.css?inline";

export const siteStyles = unsafeCSS(globalStyles);
